import React from 'react';
import { TrainStepAgent } from '../../../commons/model/Train';
import TrainUtils from '../../../commons/model/TrainUtils';

type Props = {
  agents: TrainStepAgent[];
  displayLabel?: boolean;
};

const StepAgentList = ({ agents, displayLabel = true }: Props) => {
  return (
    <div className="step-agents">
      {agents.length === 0 && '-'}
      {agents.map((a) => (
        <span key={a.id}>
          {TrainUtils.formatAgentName(a)} {displayLabel && a.typeCode && '  (' + a.typeLabel + ')'}
        </span>
      ))}
    </div>
  );
};

export default StepAgentList;
